import { generateTestId } from "@client-shared";

export const setBatchesPageExportButtonTestId = (): string => generateTestId("BatchesPage", "export-button");
